<template>
  <div fluid class="pa-0 ma-0">
    <div class="flex justify-center h-screen">
      <div class="hidden sm:flex md:!w-1/3 sm:!w-1/2">
        <CarouselVue :images="$store.getters.uniLeft" />
      </div>
      <div class="d-xs-block flex justify-center md:!w-1/3 sm:!w-1/2 w-100 bg-black">
        <v-card no-gutters
          class="d-flex align-center justify-start flex-col !overflow-auto bg-black border-0 h-full sm:w-full w-[420px]"
          elevation="0" flat rounded="0">
          <v-avatar tile height="100" width="150" class="!overflow-visible">
            <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
          </v-avatar>
          <v-form class="w-5/6 mt-8" v-model="isFormValid">

            <h1 class="mb-6 text-4xl font-bold uppercase font-Handel for-bg">
              Sign Up
            </h1>
            <p class="text-slate-300 font-Handel">
              Please Provide few details and Sign Up <br />
              Now its easy and quick
            </p>
            <v-text-field v-model="full_name" outlined class="border-0 !rounded-none text-red font-Handel"
              color="#b99143" dark placeholder="Full Name" required :rules="nameRules"></v-text-field>
            <v-text-field v-model="email" :rules="emailRules" outlined
              class="border-0 !rounded-none text-red font-Handel" color="#b99143" dark
              placeholder="Enter Your Email Address" required></v-text-field>
            <v-text-field :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" v-model="password" outlined
              class="border-0 !rounded-none text-red font-Handel" color="#b99143" dark placeholder="Create Password"
              required :rules="[v => !!v || 'Password is required']"></v-text-field>
            <v-text-field :type="showPassword ? 'text' : 'password'" v-model="password_confirmation"
              :rules="[[v => !!v || 'Password is required'], (password === password_confirmation) || 'Password must match']"
              outlined class="border-0 !rounded-none text-red font-Handel" color="#b99143" dark
              placeholder="Confirm Password" required></v-text-field>
            <v-checkbox v-model="ex4" class="mt-0 mb-5 text-white font-Handel" dark
              label="Accept Our Terms And Conditions" color="#e8c278"></v-checkbox>
            <v-row class="" no-gutters>
              <v-col class="flex mb-5">
                <v-btn
                  class="font-Handel font-xl rounded-0 white--text bg-gradient-to-tl from-[#553900] via-[#ebae33] to-[#553900] hover:opacity-90"
                  text width="170" large @click.prevent="registerUser" :disabled="!isFormValid || !ex4" :loading="signUpLoading">
                  Sign Up
                </v-btn>
                <v-btn class="ml-5 font-Handel font-xl rounded-0 white--text md:ml-10 hover:opacity-90" text width="170"
                  dark large @click.prevent="registerUser" color="#666563" to="/login">
                  Log In
                </v-btn>
              </v-col>
              <v-col class="pl-4"> </v-col>
            </v-row>
          </v-form>
        </v-card>
      </div>
      <!-- Right panel will go here -->
      <div class="hidden w-1/3 md:flex">
        <CarouselVue :images="$store.getters.uniRight" />
      </div>
    </div>
  </div>
</template>

<script>
import CarouselVue from "../../../components/auth/Carousel.vue";

export default {
  components: {
    CarouselVue,
  },
  data() {
    return {
      signUpLoading: false,
      isFormValid:false,
      ex4: false,
      full_name: "",
      email: "",
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || 'Name is required',
      ],
      showPassword: false,
      password: "",
      password_confirmation: "",
      role: "user",
    };
  },
  methods: {
    async registerUser() {
      try {
        this.signUpLoading = true;
        const { full_name, email, password, password_confirmation, role } =
          this;
        await this.$store.dispatch("Register", {
          full_name,
          email,
          password,
          password_confirmation,
          role,
        });
        // this.$router.push("/straight/profiles")
      } catch (error) {
        console.error(error);
      } finally {
        this.signUpLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.for-bg {
  background: linear-gradient(350deg,
      rgba(157, 115, 31, 1) 49%,
      rgba(219, 182, 112, 1) 56%,
      rgba(157, 115, 31, 1) 64%,
      rgba(219, 182, 112, 1) 75%,
      rgba(157, 115, 31, 1) 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.v-text-field--outlined:deep(fieldset) {
  border-color: #7f6415;
}

.v-text-field--outlined:deep(input) {
  color: #7f6415 !important;
}

.v-text-field--outlined:deep(input::placeholder) {
  color: #7f6415 !important;
}
.v-text-field--outlined:deep(.v-icon) {
  color: #7f6415 !important;
}

.v-input--checkbox:deep(.v-input--selection-controls__input) {
  color: #7f6415 !important;
}

.v-input--checkbox:deep(label) {
  color: #cbd5e1 !important;
  font-size: 14px;
}

.v-input--checkbox:deep(i) {
  color: #9d731f !important;
}

.text-red:deep(input:-webkit-autofill),
.text-red:deep(input:-webkit-autofill:hover),
.text-red:deep(input:-webkit-autofill:focus) {
  -webkit-text-fill-color: #7f6415 !important;
  -webkit-box-shadow: 0 0 0px 40rem rgb(0, 0, 0) inset !important;
}
</style>
